module.exports = __webpack_public_path__ + "static/media/emoticon-emotion-expression-laugh-svgrepo-com.d7b5f7be.svg";